import { useEffect, useState } from 'react'
import { useAtom } from 'jotai'
import { Box, Heading, Flex, VStack, Divider, Center, Link } from '@chakra-ui/react'
import { useTabs, useFreeTitles, useMetaWithPage } from '@!/Hooks'
import { ListItem } from '@!/Store/SearchList/components/ListItem'
import { TagItem } from '@!/Store/Home/components'
import { Paginate } from '@!/components/Paginate/Paginate'
import { breadcrumbAtom } from '@!/atoms/breadcrumbAtom'
import { CircularProgressModal } from '@!/components/Modal'

const SearchFree = ({ genreTabName }) => {
  const { currentTab, tabs } = useTabs(genreTabName, '/store/search/free', true)
  const { genreName, genreLabel, label: tabLabel } = currentTab
  const isActive = (index) => index === currentTab.index
  const [, setBreadcrumb] = useAtom(breadcrumbAtom)

  useEffect(() => {
    setBreadcrumb([{ name: 'マンガBANGブックス', ref: '/' }, { name: 'おすすめ無料作品一覧' }])
  }, [setBreadcrumb])

  const [currentPage, setCurrentPage] = useState(1)
  const { data, isLoading } = useFreeTitles(genreTabName === 'home' ? null : genreTabName, currentPage)
  const titles = data?.titles || []
  const pagination = data?.pagination || {}

  const handlePageChange = (page) => {
    setCurrentPage(page)
    window.scrollTo(0, 0)
  }

  const handleTabChange = (tab) => {
    let url = '/store/search/free'

    if (tab.name !== 'home') {
      url += `/${tab.name}`
    }

    window.location.href = url
  }

  // meta_tag の title と description にページ番号を追加する
  useMetaWithPage(currentPage, currentTab, '無料おすすめ一覧')

  return (
    <>
      <Box>
        <Heading as="h1" fontSize="2xl" pt={6} px={4}>
          おすすめ無料作品一覧
        </Heading>
        <Flex flexWrap="wrap" gap={1} p={4}>
          {tabs.map((tab, index) => (
            <Box key={tab.name}>
              <TagItem
                name={tab.name === 'home' ? '総合' : tab.label}
                as="a"
                whiteSpace="nowrap"
                bg={isActive(index) && 'label.primary'}
                color={isActive(index) && 'label.white'}
                fontSize="xs"
                px={3}
                cursor="pointer"
                onClick={() => {
                  handleTabChange(tab)
                }}
              />
            </Box>
          ))}
        </Flex>
      </Box>
      <Divider />
      <VStack spacing={0} divider={<Divider />} px={4}>
        {titles.map((title) => (
          <ListItem key={`search-free-list-item-${title.title_id}`} bookTitle={{ ...title, price: 0 }} />
        ))}
      </VStack>

      {pagination.current_page && (
        <Center py={6}>
          <Paginate currentPage={pagination.current_page} totalCount={pagination.total_count} perPage={pagination.per_page} onPageChange={handlePageChange} />
        </Center>
      )}

      <Center pb={4}>
        <Link href={currentTab.url} fontSize="xs">
          {genreName ? `${genreLabel}TOP` : tabLabel}に戻る
        </Link>
      </Center>

      <CircularProgressModal isOpen={isLoading} />
    </>
  )
}

export default SearchFree
